import * as api from '@/api'
import dexie from '@/utils/dexie'
import store from '@/store'
import router from '@/router'
import * as general from '@/utils/general'

const manifest = {

  async downloadManifest(url) {
    general.statusMessage('Downloading Manifest...', 'info', true);
    general.debug('download', api.URL_DOMAIN + url);
    console.time('downloadManifest');
    let newManifest;
    await fetch(api.URL_DOMAIN + url)
      .then(response => response.json())
      .then(response => {
        newManifest = response;
      });
    await this.storeManifest(newManifest);
    general.timeEnd('downloadManifest');
    general.statusClear();
  },

  async storeManifest(manifest) {
    general.statusMessage('Storing Manifest...', 'info', true);
    general.debug('storeManifest');
    try {
      general.debugMobile('manifest.length', JSON.stringify(manifest).length / 1024 / 1024);
      await dexie.manifest.clear();
      console.time('bulkAdd');
      await dexie.transaction('rw', dexie.manifest, () => {
        dexie.manifest.bulkPut(Object.keys(manifest).map(table => (manifest[table])), Object.keys(manifest));
      }).catch('DataError', e => {
        general.debugMobile('transaction error', e.message);
      });
      general.debugMobile('blukadd end');
      general.timeEnd('bulkAdd');
    } catch (e) {
      console.error('error', e.message);
    }
    general.statusClear();
  },

  async fetchManifest() {
    general.statusMessage('Checking Manifest Version...', 'info', true);
    let manifestUrl;
    await api.getManifest()
      .then(manifest => {
        general.debug('manifest fetch');
        if (manifest) {
          general.debug('manifest', manifest);
          if (!localStorage || (manifest.version && manifest.version != localStorage.getItem('manifestVersion'))) { //TODO
            manifestUrl = manifest.jsonWorldContentPaths.en;
            if (localStorage) {
              localStorage.setItem('manifestVersion', manifest.version);
            }
          }
          if (localStorage) {
            localStorage.setItem('manifestChecked', new Date);
          }
        }
      });
    if (manifestUrl) {
      await this.downloadManifest(manifestUrl);
    }
    general.statusClear();
  },

  async checkManifest() {
    console.time('checkManifest');
    if (await dexie.manifest.count() == 0) {
      if (localStorage) {
        localStorage.setItem('manifestVersion', '');
      }
      await this.fetchManifest();
      return;
    }
    if (localStorage && localStorage.getItem('manifestChecked')) {
      let ms = new Date - new Date(localStorage.getItem('manifestChecked'));
      general.debug('manifest age in ms', ms);
      if (ms > 60 * 60 * 1000) { // 1 HOUR
        await this.fetchManifest();
      }
    } else {
      await this.fetchManifest();
    }
    general.timeEnd('checkManifest');
  },

  async readAll() {
    if (router.currentRoute.params.players) {
      await this.checkManifest();
      general.statusMessage('Reading Manifest...', 'info', true);
      console.time('readAll');
      await dexie.manifest.each((row, cursor) => {
        this[cursor.key] = row;
      });
      general.timeEnd('readAll');
      general.statusClear();
      store.state.manifestLoaded = true;
    }
  },

}

export default manifest;